import { createSlice } from "@reduxjs/toolkit";
import { pdfPreferencesDefaults } from "../../components/modal/download-pdf/defaults/pdf-preferences";
const initialState = {
    hideFirstPage: pdfPreferencesDefaults.hideFirstPage,
    hideLastPage: pdfPreferencesDefaults.hideLastPage,
    pageMargin: pdfPreferencesDefaults.pageMargin,
    pageOrientation: pdfPreferencesDefaults.pageOrientation,
    pageSize: pdfPreferencesDefaults.pageSize
};
const slice = createSlice({
    initialState,
    name: "pdfPreferencesReducers",
    reducers: {
        changePdfPreferences: (state, action) => {
            if (action.payload) {
                Object.assign(state, action.payload);
            }
        },
        resetPdfPreferences: (state) => {
            Object.assign(state, initialState);
        }
    }
});
export const pdfPreferencesReducers = slice.reducer;
export const { changePdfPreferences, resetPdfPreferences } = slice.actions;
